import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,[_c(VRow,_vm._l((_vm.closedPeriodList),function(closedPeriod){return _c('ClosedPeriodCard',{key:closedPeriod.closedPeriodId,attrs:{"closedPeriod":closedPeriod,"restaurant":_vm.restaurant,"room":_vm.room},on:{"delete-closed-period":_vm.removeClosedPeriod}})}),1),_c(VRow,[_c('ClosedPeriodCard',{attrs:{"room":_vm.room,"restaurant":_vm.restaurant},on:{"new-closed-period":_vm.addClosedPeriod}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }